<template>
  <div :id="outerId" class="clearfix" :style="{ minHeight: minHeight + 'px', width: '100%' }">
    <div :id="chartId" :style="{ minHeight: minHeight + 'px', width: '100%' }">

    </div>
  </div>
</template>
<script>
  import ChartMixin from './mixins/chart'
  export default {
    name: 'SimpleBar',
    mixins: [ChartMixin],
    props: {
      chartData: {
        /*
        * Data must be in the structure: {
        * categoryField: 'val',
        * valueField: 'val',
        * }
        * where categoryField will equal this.props.categoryField --> x axis
        * where valueField will equal this.props.valueField --> y axis
        */
        type: Array,
        required: true
      },
      categoryField: {
        type: String,
        required: true
      },
      valueField: {
        type: String,
        required: true
      }
    },
    methods: {
      init (data) {
        this.chart = window.AmCharts.makeChart(this.chartId, {
          type: 'serial',
          theme: 'light',
          dataProvider: this.chartData,
          valueAxes: [
            {
              gridColor: '#FFFFFF',
              gridAlpha: 0.2,
              dashLength: 0
            }
          ],
          gridAboveGraphs: true,
          startDuration: 1,
          graphs: [
            {
              balloonText: '[[category]]: <b>[[value]]</b>',
              fillAlphas: 0.8,
              lineAlpha: 0.2,
              type: 'column',
              valueField: this.valueField
            }
          ],
          chartCursor: {
            categoryBalloonEnabled: false,
            cursorAlpha: 0,
            zoomable: false
          },
          categoryField: this.categoryField,
          categoryAxis: {
            gridPosition: 'start',
            gridAlpha: 0,
            tickPosition: 'start',
            tickLength: 20
          },
          export: {
            enabled: true
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/charts/SimpleBar.vue